import React from "react";
import { FaInfoCircle } from "react-icons/fa";
import { PartyTypeTag } from "./BillToPartyTag";
import BillToPicker from "./BillToPicker";

const PICKER_INFO =
  "This client is not billed directly. Pick the company or person its invoices are addressed to, or add a new one. " +
  "It can still be changed per invoice. To bill the client itself, use the Bill To switch in the Company or " +
  "Personal Details section.";

/**
 * Billing block for the Add / Edit Tenant forms.
 *
 * The "Bill To this company" / "Bill To this person" switches live in the Company and Personal
 * sections ({@link BillToSelfSwitch}). This block summarises the choice and, when neither switch
 * is on, lets staff pick the default Bill To from the existing list (or create one).
 *
 * @param {object} props
 * @param {string|number} [props.clientId] - omit on create
 * @param {""|"Company"|"Individual"} props.billToAs - who the client is billed as, "" = someone else
 * @param {string} props.companyName
 * @param {string} props.personName
 * @param {string} props.billToId - selected default when billed to someone else
 * @param {(id: string) => void} props.onBillToChange
 * @param {string} [props.sectionClassName] - divider class of the host form
 */
function TenantBillToSection({
  clientId,
  billToAs,
  companyName,
  personName,
  billToId,
  onBillToChange,
  sectionClassName = "edittenant-section-divider"
}) {
  const selfName = billToAs === "Company" ? companyName : personName;
  return (
    <div className={`form-section ${sectionClassName}`}>
      <h2 className="section-title">Billing</h2>
      <div className="form-grid">
        {billToAs ? (
          <div className="form-group bill-to-summary" style={{ gridColumn: "1 / -1" }}>
            <div className="bill-to-summary__card">
              <PartyTypeTag
                type={billToAs === "Company" ? "Organization" : "Individual"}
                label={billToAs === "Company" ? "Company" : "Individual"}
              />
              <div className="bill-to-summary__body">
                <div className="bill-to-summary__name">{(selfName || "").trim() || "This client"}</div>
                <div className="bill-to-summary__hint">
                  Invoices are addressed to {billToAs === "Company" ? "this company" : "this person"}. Turn the switch
                  off in the {billToAs === "Company" ? "Company" : "Personal"} Details section to bill someone else.
                  GSTIN, PAN or an international tax ID are kept under Finance &gt; Bill To Parties.
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="form-group">
            <label>
              Default Bill To
              <FaInfoCircle
                className="services-info-icon"
                style={{ marginLeft: 6, verticalAlign: "middle" }}
                title={PICKER_INFO}
                aria-label={PICKER_INFO}
              />
            </label>
            <BillToPicker
              clientId={clientId}
              value={billToId}
              onChange={(id) => onBillToChange(id)}
              autoSelectDefault={false}
              excludeSelf
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default TenantBillToSection;
